import btnStyles from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { gunterzBold } from '@/theme/fonts';
import type { SocialLinkItemType } from '@/types';
import { useLingui } from '@lingui/react';
import { Button, Card, Modal, Paper, Stack, Text, rem } from '@mantine/core';
import { IconArrowUpRight } from '@tabler/icons-react';
import { useCallback } from 'react';
import type { SocialDialogType } from '.';
import classes from './SocialAuthDialog.module.css';
export type SocialAuthDialogProps = SocialLinkItemType & {
  stack: SocialDialogType;
};
export const SocialAuthDialog: React.FC<SocialAuthDialogProps> = ({
  stack,
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  const handleLinkSocial = useCallback(() => {
    stack.close('social-link');
    stack.open('success');
  }, [stack]);
  return <Modal.Root {...stack.register('social-link')} centered classNames={classes}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header px={20} pt={32} pb={24}>
          <Modal.Title className={gunterzBold.className}>
            {i18n._('Link account')}
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body px={20} pb={32}>
          <Stack align="center" gap={20}>
            <Card radius={5} bg="var(--bg-400)">
              <Stack align="center" gap={0}>
                <Paper bg="var(--bg-500)" p={12} radius={5}>
                  <Icons className={props.iconClassName} fontSize={40} color="var(--text-prime)" />
                </Paper>

                <Text fz="lg" ta="center" lh={rem(18)} className={gunterzBold.className} c="var(--text-white)" mt={24}>
                  {i18n._('Link ')}
                  <Text span c="var(--text-prime)">
                    {props.title}
                  </Text>
                  {i18n._(' with primeroll')}
                </Text>
                <Text fz={13} c="var(--text-dark)" ta="center" mt={10}>
                  {i18n._('We’re redirecting you to Steam to connect your account securely. Please complete the steps there and you’ll be brought back here.')}
                </Text>
              </Stack>
            </Card>

            <Button fz={13} h={46} rightSection={<IconArrowUpRight size={24} />} classNames={btnStyles} onClick={handleLinkSocial}>
              {i18n._('continue')}
            </Button>
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>;
};